import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import VueFire from "vuefire";
import * as filters from "./utils/filters";
import * as VueGoogleMaps from "vue2-google-maps";
import VTooltip from "v-tooltip";
import ToggleButton from "vue-js-toggle-button";
import Tabs from "vue-tabs-component";
import VModal from "vue-js-modal";
import { getEnvironmentConfig, getApiEndpoint } from "./config/environment";
import ToastPlugin from "./utils/toast";
import { restoreRememberMeToken } from "./utils/rememberMeAuth";
import { isAdminUser, isAdminAccessAllowed } from "./utils/adminAccess";
import "./utils/toast.css";

// Restore remembered auth before vue-auth installs route guards.
restoreRememberMeToken();

Vue.use(Tabs);
Vue.use(VTooltip);
Vue.use(ToggleButton);
Vue.use(VModal);
Vue.use(ToastPlugin);
Vue.config.productionTip = false;

Object.keys(filters).forEach((filterName) => {
  Vue.filter(filterName, filters[filterName]);
});
Vue.prototype.$isStage = 0;
Vue.prototype.$fbDbEntry = "racers";
/* Check if status is Live/Staging */
const status = window.localStorage.getItem("envStatus");
if (status) {
  Vue.prototype.$envStatus = status;
} else {
  Vue.prototype.$envStatus = "Staging";
}

const distanceIn = window.localStorage.getItem("distanceIn");
if (distanceIn) {
  Vue.prototype.$envdistanceIn = distanceIn;
} else {
  Vue.prototype.$envdistanceIn = "Km";
}

// Set API endpoint from environment configuration (loaded from .env file)
const envConfig = getEnvironmentConfig();
Vue.prototype.$expressApi = getApiEndpoint();
console.log("Using API endpoint from .env:", Vue.prototype.$expressApi);

Vue.use(VueResource);
Vue.use(VeeValidate);
Vue.use(VueFire);

Vue.use(VTooltip);

Vue.use(VueGoogleMaps, {
  load: {
    key: envConfig.GOOGLE_MAPS_API_KEY,
    v: "3.36",
  },
});
Vue.http.options.root = envConfig.API || envConfig.API_ENDPOINT || "";

Vue.router = router;

Vue.use(require("@websanova/vue-auth"), {
  auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/vue-resource.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  rolesVar: "role",
  loginData: {
    url: "authenticate?panel-trainer",
    method: "POST",
    redirect: "/",
    fetchUser: true,
  },
  fetchData: { url: "account", method: "GET" },
  refreshData: { url: "api/auth/refresh", method: "GET", enabled: false },
  parseUserData: (data) => {
    return data || {};
  },
});

import DevModeService from "./services/DevModeService";

// Helper to check dev mode state with access to current route query
Vue.prototype.$isDevMode = function () {
  return DevModeService.isEnabled(this.$route ? this.$route.query : null);
};

Vue.prototype.$isAdminUser = function (user) {
  if (user) {
    return isAdminUser(user);
  }

  const authUser = this.$auth && this.$auth.user ? this.$auth.user() : null;
  const trainer = this.$store && this.$store.getters ? this.$store.getters["Trainer/trainer"] : null;
  return isAdminAccessAllowed(authUser, trainer);
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js